<template>
 
</template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import AccountService from "@/accounts/accountsService.js";
  export default {
    mounted() {
      if (this.$route.query.token) {
        var instance = this;
        instance.$vs.loading()
        TCVelikClient.PostRelative("/api/accounts/VerifyLoginLink?token=" + this.$route.query.token).then(function (response) {
          if (response && response.data) {
            AccountService.cleanUserLocalStorageItems();
            localStorage.setItem(location.hostname + "-token", response.data);
            document.location.href = "/pages/home"
          }
          }).catch(err => {
            document.location.href = "/pages/login"
        });
      }
      else {
        document.location.href = "/pages/login"
      }
    }
  }
</script>
